const inputStyle = {
  border: '1px solid var(--color-neutral-400)',
  padding: '5px 8px',
  fontSize: 12,
  background: 'var(--color-bg)',
  color: 'var(--color-text)',
  minWidth: 0,
  width: '100%',
  boxSizing: 'border-box',
}

const panelStyle = {
  position: 'relative',
  border: '1px solid var(--color-neutral-400)',
  padding: '10px 12px',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
}

const titleStyle = {
  fontFamily: 'var(--font-heading)',
  fontSize: 10,
  letterSpacing: 3,
  color: 'var(--color-accent-800)',
  fontWeight: 600,
}

const fieldLabel = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  fontSize: 9.5,
  letterSpacing: 1,
  color: 'var(--color-neutral-600)',
}

const Corners = () => (
  <>
    <i className="corner tl" />
    <i className="corner tr" />
    <i className="corner bl" />
    <i className="corner br" />
  </>
)

export default function Inspector({
  seat,
  selIsOpp,
  view,
  frame,
  notation,
  onNotation,
  onApplyNotation,
  onSeatName,
  onSeatScore,
  onSeatRiichi,
  onSeatRevealed,
  onRound,
  onWall,
  onHonba,
  onSticks,
  onTitle,
  onBody,
  onUkeireTiles,
  onUkeireNote,
  onWin,
}) {
  const hideHand = view === 'focus' && selIsOpp
  return (
    <>
      <div className="blueprint" style={panelStyle}>
        <Corners />
        <div style={titleStyle}>PLAYER · {seat.name.toUpperCase()}</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <label style={{ flex: 1, ...fieldLabel }}>
            NAME
            <input value={seat.name} onChange={onSeatName} style={inputStyle} />
          </label>
          <label style={{ width: 90, ...fieldLabel }}>
            SCORE
            <input type="number" step="100" value={seat.score} onChange={onSeatScore} style={inputStyle} />
          </label>
        </div>
        <div style={{ display: 'flex', gap: 14, fontSize: 11.5 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
            <input type="checkbox" checked={seat.riichi} onChange={onSeatRiichi} />
            Riichi
          </label>
          {selIsOpp && !hideHand && (
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
              <input type="checkbox" checked={seat.revealed} onChange={onSeatRevealed} />
              Reveal hand
            </label>
          )}
        </div>
        {!hideHand && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <span style={{ fontSize: 9.5, letterSpacing: 1, color: 'var(--color-neutral-600)' }}>
              HAND NOTATION <span style={{ color: 'var(--color-neutral-400)' }}>(x = unknown, e.g. 234m55zxx)</span>
            </span>
            <div style={{ display: 'flex', gap: 6 }}>
              <input
                value={notation}
                onChange={onNotation}
                placeholder="234789m3588p456s"
                style={{ ...inputStyle, flex: 1, minWidth: 0, fontFamily: 'ui-monospace,monospace' }}
              />
              <button className="btn btn-secondary" onClick={onApplyNotation} style={{ height: 31, padding: '0 12px', fontSize: 11 }}>
                Apply
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="blueprint" style={panelStyle}>
        <Corners />
        <div style={titleStyle}>ROUND DATA</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <label style={{ flex: 1.4, ...fieldLabel }}>
            ROUND
            <input value={frame.round} onChange={onRound} style={inputStyle} />
          </label>
          <label style={{ flex: 1, ...fieldLabel }}>
            WALL
            <input type="number" min="0" value={frame.wall} onChange={onWall} style={inputStyle} />
          </label>
          <label style={{ flex: 1, ...fieldLabel }}>
            HONBA
            <input type="number" min="0" value={frame.honba} onChange={onHonba} style={inputStyle} />
          </label>
          <label style={{ flex: 1, ...fieldLabel }}>
            STICKS
            <input type="number" min="0" value={frame.sticks} onChange={onSticks} style={inputStyle} />
          </label>
        </div>
        <span style={{ fontSize: 10, color: 'var(--color-neutral-500)' }}>
          Dora indicator: click the DORA chip on the canvas, then a palette tile.
        </span>
      </div>

      <div className="blueprint" style={panelStyle}>
        <Corners />
        <div style={titleStyle}>WAIT / RESULT</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <label style={fieldLabel}>
            UKEIRE TILES
            <input
              value={(frame.ukeire?.tiles || []).join(' ')}
              onChange={onUkeireTiles}
              placeholder="4p 5s"
              style={{ ...inputStyle, fontFamily: 'ui-monospace,monospace' }}
            />
          </label>
          <label style={fieldLabel}>
            NOTE
            <input
              value={frame.ukeire?.note ?? ''}
              onChange={onUkeireNote}
              placeholder="4 tiles live"
              style={inputStyle}
            />
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11.5, cursor: 'pointer' }}>
            <input type="checkbox" checked={!!frame.win} onChange={onWin} />
            Tsumo win
          </label>
        </div>
      </div>

      <div className="blueprint" style={{ ...panelStyle, gap: 6, flex: 1 }}>
        <Corners />
        <div style={titleStyle}>TEACHING TEXT</div>
        <input
          value={frame.title}
          onChange={onTitle}
          placeholder="Concept title"
          style={{
            border: '1px solid var(--color-neutral-400)',
            padding: '6px 9px',
            fontSize: 13,
            fontWeight: 600,
            background: 'var(--color-bg)',
            color: 'var(--color-text)',
          }}
        />
        <textarea
          value={frame.body}
          onChange={onBody}
          rows="4"
          placeholder="What this frame teaches…"
          style={{
            border: '1px solid var(--color-neutral-400)',
            padding: '6px 9px',
            fontSize: 12,
            lineHeight: 1.5,
            fontFamily: 'var(--font-body)',
            resize: 'vertical',
            background: 'var(--color-bg)',
            color: 'var(--color-text)',
          }}
        />
      </div>
    </>
  )
}
